import PropTypes from 'prop-types';
import { useHasCoarsePointer } from '../../../hooks/useHasCoarsePointer';

/**
 * Touch-only action bar for multi-point drawing tools (#747).
 *
 * On a coarse (touch) pointer there is no Enter/Escape key and double-tap to
 * finish is unreliable on iOS Safari — and an open path like the "Weg" has no
 * tap-near-start auto-close at all. So on touch the drawing tools show explicit
 * "Fertig"/"Abbrechen" buttons. Hidden entirely on mouse/pen, where the existing
 * keyboard + double-click + auto-close flow stays untouched.
 */
export default function DrawingToolActions({ canFinish = false, onFinish, onCancel, finishLabel = 'Fertig' }) {
  const coarse = useHasCoarsePointer();
  if (!coarse) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        gap: 12,
      }}
    >
      <button
        type="button"
        onClick={onCancel}
        className="px-5 py-3 rounded-lg border border-gray-300 bg-white/95 text-gray-700 font-medium shadow-lg active:bg-gray-100"
      >
        Abbrechen
      </button>
      <button
        type="button"
        onClick={onFinish}
        disabled={!canFinish}
        className="px-6 py-3 rounded-lg bg-emerald-500 text-white font-semibold shadow-lg active:bg-emerald-600 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {finishLabel}
      </button>
    </div>
  );
}

DrawingToolActions.propTypes = {
  canFinish: PropTypes.bool,
  onFinish: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  finishLabel: PropTypes.string,
};
